import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';
import { POST_MESSAGES_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';

const SYNC_INTERVAL_MS = 3000;
const syncWithParent = (conversions, focusedConversionId) => {
    if (!window.parent) {
        return;
    }

    window.parent.postMessage(
        {
            type: POST_MESSAGES_TYPES.SYNC_CONVERSIONS,
            conversions,
            focusedConversionId,
        },
        '*'
    );
};

export const useSyncConversionsWithParent = conversions => {
    const [focusedConversionId, setFocusedConversionId] = useState(undefined);
    const [existingConversionIds, setExistingConversionIds] = useState([]);

    useEffect(() => {
        const handleExistingConversionsMsg = event => {
            if (event.data?.type === POST_MESSAGES_TYPES.EXISTING_CONVERSIONS && event.data.existingConversionIds) {
                setExistingConversionIds(event.data.existingConversionIds);
            }
        };

        window.addEventListener('message', handleExistingConversionsMsg);
        return () => window.removeEventListener('message', handleExistingConversionsMsg);
    }, []);

    useEffect(() => syncWithParent(conversions, focusedConversionId), [focusedConversionId, conversions]);

    useInterval(() => syncWithParent(conversions, focusedConversionId, existingConversionIds), SYNC_INTERVAL_MS);

    return {
        setFocusedConversionId,
        existingConversionIds,
    };
};
